const LEGACY_DESCRIPTION_MAP = {
  'values updated the booking': 'Booking details were updated',
  'Booking created for first time': 'Booking created for the first time',
  'added note': 'Note added to this deal',
  'created meeting': 'Meeting scheduled',
  'Task crated for the lead': 'Task created for this deal',
  'Task details were updated': 'Task details were updated',
  'Additional service added to to the lead': 'Additional service added to this deal',
  'service created': 'Service added to this deal',
};

function parseMetadata(raw) {
  if (raw == null || raw === '') return null;
  if (typeof raw === 'object') return raw;
  const text = String(raw).trim();
  if (!text) return null;
  if (text.startsWith('{') || text.startsWith('[')) {
    try {
      return JSON.parse(text);
    } catch {
      return null;
    }
  }
  return { raw: text };
}

function isGenericDescription(text) {
  const value = String(text || '').trim().toLowerCase();
  return (
    !value ||
    value === 'values updated the booking' ||
    value === 'added note' ||
    value === 'created meeting' ||
    value.startsWith(' update the ')
  );
}

function fromMetadata(metadata) {
  if (!metadata || typeof metadata !== 'object') return null;

  if (Array.isArray(metadata.changes) && metadata.changes.length > 0) {
    return metadata.changes.join(' · ');
  }

  const stageName = metadata.stageName || metadata.stages;
  if (stageName) {
    const from = metadata.fromStage;
    if (metadata.action === 'removed') {
      return from ? `Removed from ${from}` : 'Removed from pipeline';
    }
    if (from && from !== stageName) {
      return `Moved to ${stageName} (from ${from})`;
    }
    return `Added to ${stageName}`;
  }

  if (metadata.service) {
    return `Service added: ${metadata.service}`;
  }

  if (metadata.meetingDateTime) {
    try {
      const when = new Date(metadata.meetingDateTime).toLocaleString('en-AU', {
        dateStyle: 'medium',
        timeStyle: 'short',
      });
      return `Meeting scheduled for ${when}`;
    } catch {
      return 'Meeting scheduled with client';
    }
  }

  if (metadata.taskTitle) {
    return `Task: ${metadata.taskTitle}`;
  }

  if (typeof metadata.note === 'string' && metadata.note.trim()) {
    const snippet = metadata.note.replace(/<[^>]+>/g, ' ').trim();
    if (snippet) {
      return snippet.length > 120 ? `${snippet.slice(0, 117)}...` : snippet;
    }
  }

  return null;
}

/**
 * @returns {{ activity: string, category: string | null }}
 */
export function formatBookingHistoryItem(item) {
  const title = String(item?.title || '').trim();
  let description = String(item?.description || '').trim();
  const metadata = parseMetadata(item?.metadata);

  if (LEGACY_DESCRIPTION_MAP[description]) {
    description = LEGACY_DESCRIPTION_MAP[description];
  }

  const fromMeta = fromMetadata(metadata);
  if (fromMeta && isGenericDescription(description)) {
    description = fromMeta;
  } else if (isGenericDescription(description) && title && title !== 'Booking updated') {
    description = title;
  }

  const activity = description || title || 'Activity recorded';
  const category =
    title && title !== activity && !isGenericDescription(title) ? title : null;

  return { activity, category };
}
